import script from "./HomePageTopImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomePageTopImage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__